import {Box, Button, Stack, Typography} from '@mui/material';
import {useSearchParams} from 'react-router-dom';

export default function Pagination({pagination}) {
	const [searchParams, setSearchParams] = useSearchParams();

	if (!pagination || !pagination.pagesCount) {
		return null;
	}

	const {pagesCount, pageNumber} = pagination;
	const currentPage = pageNumber || 1;

	const handlePageChange = (newPage) => {
		const params = new URLSearchParams(searchParams);
		params.set('page', newPage);
		setSearchParams(params);
	};

	const handlePrevious = () => {
		if (currentPage > 1) {
			handlePageChange(currentPage - 1);
		}
	};

	const handleNext = () => {
		if (currentPage < pagesCount) {
			handlePageChange(currentPage + 1);
		}
	};

	const getPageNumbers = () => {
		const pages = [];
		const maxVisiblePages = 5;
		let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
		let endPage = Math.min(pagesCount, startPage + maxVisiblePages - 1);

		if (endPage - startPage + 1 < maxVisiblePages) {
			startPage = Math.max(1, endPage - maxVisiblePages + 1);
		}

		if (startPage > 1) {
			pages.push(1);
			if (startPage > 2) {
				pages.push('...');
			}
		}

		for (let i = startPage; i <= endPage; i++) {
			pages.push(i);
		}

		if (endPage < pagesCount) {
			if (endPage < pagesCount - 1) {
				pages.push('...');
			}
			pages.push(pagesCount);
		}

		return pages;
	};

	return (
		<Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center', mt: 3, mb: 2}}>
			<Stack direction="row" spacing={1} alignItems="center">
				<Button
					variant="outlined"
					size="small"
					onClick={handlePrevious}
					disabled={currentPage === 1}
				>
					السابق
				</Button>

				{getPageNumbers().map((page, index) => {
					if (page === '...') {
						return (
							<Typography key={`ellipsis-${index}`} sx={{px: 1}}>
								...
							</Typography>
						);
					}

					return (
						<Button
							key={page}
							variant={currentPage === page ? 'contained' : 'outlined'}
							size="small"
							onClick={() => handlePageChange(page)}
							sx={{minWidth: 40}}
						>
							{page}
						</Button>
					);
				})}

				<Button
					variant="outlined"
					size="small"
					onClick={handleNext}
					disabled={currentPage === pagesCount}
				>
					التالي
				</Button>
			</Stack>
		</Box>
	);
}
